import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';
import { PersonalInfoComponentView } from '../PersonalInfoComponentView';

/**
 * 個人情報登録モード
 */
export class PersonalInfoMode extends WprBaseViewModeInfo<PersonalInfoComponentView> {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('personalInfoMode');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('入力完了');
		list.push('未入力');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		this.addControl('toNext', {
			enabled: [
				{ mode: '未入力', value: false },
				{ mode: '入力完了', value: true },
			],
		});
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		if (this.view.isInput() === false)
			return '未入力';
		else
			return '入力完了';
	}
	// --------------------------------------------------------------------------
}
